"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthMeasurementType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var HealthMeasurementType_Factory = /** @class */ (function () {
    function HealthMeasurementType_Factory() {
    }
    HealthMeasurementType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    HealthMeasurementType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return HealthMeasurementType_Factory;
}());
exports.HealthMeasurementType_Factory = HealthMeasurementType_Factory;
